import TransactionFail from "@/assets/bank-failure.json";
import PageTransition from "@/components/ui/PageTransition";
import { useNavigate } from "@tanstack/react-router";
import { ArrowRightIcon, XIcon } from "lucide-react";
import Lottie from "react-lottie";
import { Button } from "../../ui/button/button";
import { static_errors } from "@/axios/constants";
import { getHelpCenterUrl } from "@/lib/utils";

type Props = {
	onTryAgainClick: () => void;
	onClose?: () => void;
	errorMessage?: React.ReactNode;
	transactionNumber?: number;
	tryAgainLabel?: string;
};

const CardFailedPage = (props: Props) => {
	const {
		onTryAgainClick,
		onClose,
		errorMessage,
		transactionNumber,
		tryAgainLabel = "Try again",
	} = props;
	const lottieConfig = {
		loop: false,
		autoplay: true,
		animationData: TransactionFail,
		rendererSettings: {
			preserveAspectRatio: "xMidYMid slice",
		},
	};

	const navigate = useNavigate();
	return (
		<PageTransition>
			<div className="relative flex flex-col items-center kashu-container bg-white text-textDark h-[100dvh] text-center">
				<XIcon
					className="absolute right-0 -top-2"
					role="button"
					onClick={
						onClose ??
						(() =>
							navigate({
								to: "/main/card",
							}))
					}
				/>
				<div className="mt-10">
					<div className="max-w-80 mx-auto">
						<Lottie options={lottieConfig} />
					</div>
				</div>
				<div className="mt-14">
					<h1 className="text-4xl font-bold text-textDark">Uh oh! Something</h1>
					<h1 className="text-4xl font-bold text-textDark">went wrong.</h1>
				</div>
				<div className="pt-3 text-sm font-medium text-textDark pb-9">
					{errorMessage || static_errors.unexpected_contact_support}
					{typeof transactionNumber === "number" && (
						<div className="mt-3 text-xs text-gray-500">
							Transaction #{transactionNumber}
						</div>
					)}
				</div>
				<Button
					className="w-full mb-4"
					variant={"outline"}
					onClick={onTryAgainClick}
				>
					{tryAgainLabel}
				</Button>
				<Button
					className="w-full text-base font-bold text-white rounded-xl"
					onClick={() => window.open(getHelpCenterUrl(), "_blank")}
				>
					Contact Support
					<ArrowRightIcon className="w-5 h-5" />
				</Button>
			</div>
		</PageTransition>
	);
};

export default CardFailedPage;
